/**
 * Display-only mirror of PLAN_LIMITS.maxShops in menu-points-kernel/src/common/enums/Plans.ts.
 * Gating decisions must use shop_quota from the billing API.
 */
export const PLAN_MAX_SHOPS: Record<string, number | null> = {
  FREE: 1,
  PLUS: 2,
  PRO: null,
  ENTERPRISE: null,
}

/** Display-only mirror of PLAN_LIMITS.maxItems — gating must use item_quota from billing API. */
export const PLAN_MAX_ITEMS: Record<string, number | null> = {
  FREE: 50,
  PLUS: null,
  PRO: null,
  ENTERPRISE: null,
}
